import React from 'react';
import { Chip, styled, Typography } from '@mui/material';
import { colors } from '../../styles/globalStyles';
import { ReactComponent as MessagesIcon } from '../../images/messages_icon.svg';


const TypographyAboveChip = styled(Typography)({
    marginLeft: 10,
    marginBottom: 4,

    fontSize: 9,
    fontWeight: 500,
    lineHeight: '122%',
});

const StyledChip = styled(Chip)(({ height, background, text_color, radius, isGray }) => ({
    height: height || 52,

    background: isGray ? colors.gray : background,
    color: text_color,

    borderRadius: radius || 27,
}));

const TypographyChip = styled(Typography)({
    display: 'flex',
    alignItems: 'baseline',

    fontSize: 24,
    fontWeight: 500,
    lineHeight: '129%',

    '& svg': {
        marginLeft: 10,
        color: colors.yellow,
    },
});

const StarOrMessageChip = ({ title, number, messageIcon, height, background, text_color, radius, isGray }) => {
    return (
        <>
            <TypographyAboveChip>{title}</TypographyAboveChip>
            <StyledChip
                label={
                    <TypographyChip>
                        {number}
                        {messageIcon && <MessagesIcon />}
                    </TypographyChip>
                }
                height={height}
                background={background}
                text_color={text_color}
                radius={radius}
                isGray={isGray}
            />
        </>
    );
};

export default StarOrMessageChip;
